import { LocationQuery } from 'vue-router';
import { cacheFirstConfig, http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { Competence } from './competence.interface';

export class CompetenceService {
   async searchCompetences(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Competence>>>(`/competences`, { params: { ...query } });
      return response.data;
   }
   async getCompetences(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Competence>>>(`/competences`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
